import React, { useCallback, useState } from 'react';
import { Breadcrumb, Spin, Upload, UploadProps } from 'antd';
import { Link } from 'react-router-dom';

import Button from 'components/button';
import { Fence, TUploadedFence } from 'interfaces/fences';
import CardCercaEletronica from '../Components/card';
import { Container } from '../styles';
import { FormUploadModal } from '../Components/formUploadModal';
import { ServiceCerca } from 'services/modulos/serviceCerca';
import { toast } from 'react-toastify';
import { parseKmlToFences } from './parseKml';

export const UploadFences = () => {
  const [loading, setLoading] = useState(false);
  const [uploadedFences, setUploadedFences] = useState<TUploadedFence[]>([]);
  const [openUploadModal, setOpenUploadModal] = useState(false);

  const handleDeleteUploadedFence = useCallback((index: string | number) => {
    setUploadedFences(prev => prev.filter((_, i) => i !== Number(index)));
  }, []);

  const handleSaveAllUploadedFences = useCallback(
    async (ais: string[], period: string[]) => {
      try {
        setLoading(true);
        await Promise.all(
          (uploadedFences || []).map(f => {
            const newFence: Fence = {
              nome: f.nome,
              descricao: '',
              dataInicial: period[0],
              dataFinal: period[1],
              points: f.formattedCoords,
              pontosBase: [],
              alloweds: [],
              ativo: true,
              veiculosAssociados: [],
              grupos: ais,
            };
            return ServiceCerca.createAdminCerca(newFence);
          })
        );
        setUploadedFences([]);
        setOpenUploadModal(false);
        toast.success('Cercas adicionadas');
      } catch (e: any) {
        const message =
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          'Erro ao salvar cercas. Tente novamente.';
        toast.error(message);
      } finally {
        setLoading(false);
      }
    },
    [uploadedFences]
  );

  const readAndParseKml = useCallback((file: File) => {
    const fileReader = new FileReader();
    fileReader.onload = e => {
      const text = e?.target?.result;
      if (typeof text === 'string') {
        parseKmlToFences(text).then(parsedData => {
          setUploadedFences(prev => [...prev, ...parsedData]);
        });
      }
    };
    fileReader.readAsText(file, 'UTF-8');
  }, []);

  const uploadProps: UploadProps = {
    name: 'file',
    accept: '.kml',
    headers: {
      authorization: 'authorization-text',
    },
    showUploadList: false,
    beforeUpload: file => {
      readAndParseKml(file);
      return false; // prevent actual upload, we only parse locally
    },
    onChange(info) {
      if (info.file.status === 'done' || info.file.status === 'error') {
        const file = info.file.originFileObj;
        if (file) readAndParseKml(file);
      }
    },
  };

  return (
    <>
      <Container>
        <Breadcrumb style={{ padding: '10px' }}>
          <Breadcrumb.Item>
            {/* @ts-expect-error Server Component */}
            <Link to="/">Página Inicial</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            {/* @ts-expect-error Server Component */}
            <Link to="/cerca">Cercas</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>Upload</Breadcrumb.Item>
        </Breadcrumb>
        <Spin spinning={loading}>
          <div className="body" style={{ textAlign: 'center' }}>
            <div className="title">
              <h1>Upload de Cercas</h1>
            </div>
            <div className="buttonsDivUpload">
              <Button
                disabled={!uploadedFences.length}
                type="button"
                buttonStyle="btn--primary"
                onClick={() => setOpenUploadModal(true)}
              >
                Salvar
              </Button>
              <Upload {...uploadProps}>
                <Button type="button" buttonStyle="btn--link">
                  Upload
                </Button>
              </Upload>
            </div>
            {/* <Search className="inputButton" /> */}
            <div className="cardList">
              {uploadedFences?.map((f, i) => {
                return (
                  <CardCercaEletronica
                    id={i + ''}
                    key={i}
                    nome={`${f.nome}`}
                    feature={f}
                    veiculos={f.veiculos}
                    deleteCerca={handleDeleteUploadedFence}
                    ativo={f.ativo}
                    isFenceAdmin={false}
                    isAutor={true}
                    system={false}
                    isUpload={true}
                  />
                );
              })}
            </div>
          </div>
        </Spin>
      </Container>
      <FormUploadModal
        key={1}
        open={openUploadModal}
        setModalVisible={setOpenUploadModal}
        handleConfirmModal={handleSaveAllUploadedFences}
      />
    </>
  );
};
